import { render, staticRenderFns } from "./ActivationBriefAffiliateLinksRouterView.vue?vue&type=template&id=0e013b5c&scoped=true&"
import script from "./ActivationBriefAffiliateLinksRouterView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefAffiliateLinksRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e013b5c",
  null
  
)

export default component.exports